import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpXsrfTokenExtractor,
  HttpHeaders,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { LoganApiConfig } from '../models/services.model';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private config: LoganApiConfig;
  screens: [] = [];
  token: string | null = null;

  constructor(
    private authenticationService: AuthService,
    public tokenExtractorService: HttpXsrfTokenExtractor,
    public auth: AuthService,
    private router: Router
  ) {
    this.config = new LoganApiConfig(environment.loganConfig);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authenticationService.currentUserValue;
    const headerName = 'XSRF-TOKEN';
    const respHeaderName = 'X-XSRF-TOKEN';
    let csrfToken: any = document.cookie.replace(
      /(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/,
      '$1'
    );
   // let csrfToken = this.tokenExtractorService.getToken() as string;
    if (csrfToken != null) {
      request = request.clone({
        headers: request.headers.set(respHeaderName, csrfToken),
      });
    }

    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token.accessToken}`,
          'App-Authorization': this.config.key,
        },
      });
    } else {
      request = request.clone({
        setHeaders: { 'App-Authorization': this.config.key },
      });
    }
    return next.handle(request);
  }
}
